var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.226,
    height: 41.281,
    viewBox: "0 0 32.226 41.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "marker_copy_4",
    "data-name": "marker copy 4",
    d: "M16.112,41.281c-.064,0-10.674-9.756-14.647-18.635A19.719,19.719,0,0,1,0,15.606,15.089,15.089,0,0,1,1.266,9.532,15.536,15.536,0,0,1,4.719,4.571,16.1,16.1,0,0,1,9.841,1.226a16.651,16.651,0,0,1,12.544,0,16.1,16.1,0,0,1,5.122,3.345A15.537,15.537,0,0,1,30.96,9.532a15.087,15.087,0,0,1,1.266,6.075c0,.454-.324,5.028-1.49,7.093-2.061,4.575-5.912,9.376-8.779,12.6a79.987,79.987,0,0,1-5.845,5.983h0Zm0-29.669a4.514,4.514,0,1,0,4.514,4.514A4.519,4.519,0,0,0,16.114,11.612Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.aff7391e.svg";
export { ForwardRef as ReactComponent };